/**
 * @generated SignedSource<<14e78fcdb5e467995e1a0fed9c6513bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceRoutineTemplatesList_workspace$data = {
  readonly id: string;
  readonly routines: ReadonlyArray<{
    readonly id: string;
    readonly orgTopic: {
      readonly name: string;
    } | null;
    readonly title: string;
    readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutineTemplateListItem_Routine">;
  }> | null;
  readonly topics: ReadonlyArray<{
    readonly __typename: "OrgTopic";
  }> | null;
  readonly " $fragmentType": "WorkspaceRoutineTemplatesList_workspace";
};
export type WorkspaceRoutineTemplatesList_workspace$key = {
  readonly " $data"?: WorkspaceRoutineTemplatesList_workspace$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutineTemplatesList_workspace">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceRoutineTemplatesList_workspace",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "OrgTopic",
      "kind": "LinkedField",
      "name": "topics",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "TEMPLATE"
        }
      ],
      "concreteType": "Routine",
      "kind": "LinkedField",
      "name": "routines",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WorkspaceRoutineTemplateListItem_Routine"
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "OrgTopic",
          "kind": "LinkedField",
          "name": "orgTopic",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "routines(type:\"TEMPLATE\")"
    }
  ],
  "type": "Workspace",
  "abstractKey": null
};
})();

(node as any).hash = "f03bee3c5c64f0f8afd9faa42f95cd6b";

export default node;
